<template>
    <div class="timeRange">
        <div class="calendar" :class="[disabled ? 'tableDisabled' : '']">
            <table>
                <thead>
                <tr>
                    <th rowspan="6" class="weekRow">
                        <div class="diagonal_line"></div>
                        <div class="time">时</div>
                        <div class="minute">分</div>
                    </th>
                </tr>
                <tr>
                    <td v-for="index in 24" :key="index">{{ index - 1 }}</td>
                </tr>
                </thead>
                <tbody @mousemove.prevent="handleMouseMove">
                    <tr v-for="(item, index) in weekDate" :key="index">
                        <td>{{ item }}</td>
                        <td class="calendar-atom-time" v-for="i in 24" :key="index + '-' + (i-1)"
                            :class="{ 'active': selectCells[`${index}_${i-1}`] }"
                            @mousedown.prevent="handleMouseDown(index, i-1, $event)"
                            @mouseup.prevent="handleMouseUp(index, i-1)">
                            <!-- {{setNumTable(index, i-1)}} -->
                        </td>
                    </tr>
                    <div id="box" v-show="moveStartEvent"></div>
                </tbody>
            </table>
            <p class="dropTimesTips font12px"><span class="star">*</span>可拖动鼠标选择时间段</p>
            <div class="table-core">
                <div class="table-core-header">
                    <span class="font12px text-bold">已选时间段：</span>
                    <el-popconfirm
                        title="是否清空所有已选时间段？"
                        @confirm="handleClear"
                    >
                        <el-button slot="reference" type="text" class="clearBtn" :disabled="disabled">清空</el-button>
                    </el-popconfirm>

                </div>
                <div class="drawer_item_time_srcoll">
                    <div class="drawer_item_time">
                        <div v-for="(item, index) in times_list" :key="index" class="drawer_item_time_body font12px">
                            {{item}}
<!--                            <div v-for="(itemc, indesc) in item.data" :key="indesc">{{ itemc[0] }}</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { cloneDeep, sortBy, uniq} from 'lodash';
    export default {
        name: 'apple_drop_times',
        props:['weekDate','value', 'disabled'],
        data() {
            return {
                // 表列
                // weekDate: ['15', '45'],
                // 所选格子
                selectCells: {},
                // 所选时间数据（做提交时使用）
                selectDate: {},
                // 记录鼠标位置
                moveStartEvent: false,
                moveStartColumn: 0, // 列
                moveStarRow: 0, // 行
                moveStartX: 0,
                moveStartY: 0,
                times_list:[]
            }
        },
        watch:{
            'value': {
                handler(n) {
                    this.$nextTick(()=>{
                        this.getStringTimeToChecked(n)
                        this.times_list = n
                    })
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            // 初始
            init (data) {
                if (data && data instanceof Object) {
                    this.selectCells = data
                } else {
                    this.selectCells = {}
                }
                this.getSelectDate()
            },

            // 按下
            handleMouseDown (column, row, e) {
                if(this.disabled) return
                this.moveStartEvent = true
                this.moveStartColumn = column
                this.moveStarRow = row
                this.moveStartX = e.layerX
                this.moveStartY = e.layerY
            },

            // 松开
            handleMouseUp (column, row) {
                if(this.disabled) return
                if (this.moveStartEvent) {
                    this.moveStartEvent = false

                    const dom = this.$el.querySelector('#box')
                    dom.style.left = 0 + 'px'
                    dom.style.top = 0 + 'px'
                    dom.style.width = 0 + 'px'
                    dom.style.height = 0 + 'px'

                    const X = row - this.moveStarRow
                    const Y = column - this.moveStartColumn
                    const checked = !this.selectCells[`${column}_${row}`]

                    if (X > -1 && Y > -1) {
                    const obj = cloneDeep(this.selectCells)
                    for (let i = this.moveStartColumn; i <= column; i++) {
                        for (let j = this.moveStarRow; j <= row; j++) {
                        var key = `${i}_${j}`
                        if (checked) {
                            obj[key] = checked
                        } else if (obj[key]) {
                            delete obj[key]
                        }
                        }
                    }
                    this.selectCells = obj
                    this.$forceUpdate()
                    this.getSelectDate()
                    }
                }
                this.moveStartDay = 0
                this.moveStarTime = 0
            },

            // 滑动中
            handleMouseMove (e) {
                if (this.moveStartEvent) {
                    const dom = this.$el.querySelector('#box')
                    const X = e.layerX - this.moveStartX
                    const Y = e.layerY - this.moveStartY
                    if (X >= 0 && Y >= 0) {
                        dom.style.left = this.moveStartX + 'px'
                        dom.style.top = this.moveStartY + 'px'
                        dom.style.width = X + 'px'
                        dom.style.height = Y + 'px'
                    }
                }
            },
            // 设置数字
            setNumTable (date, setIndex) {
                return (24 * date) + Number(setIndex)

            },
            // 获得传入数字转       1_0 true 形势  list [0,1,2,3,4,5,6]   [0:15,0:45]
            getIdToString(list) {
                let obj = {}
                if(Array.isArray(list) && list.length != 0) {
                    list.forEach(item=>{
                        if(Number(item) < 24) {
                            obj[`0_${item}`] = true
                        }else{
                            let divisor = Math.floor(item / 24)
                            let remainders = item % 24
                            obj[`${divisor}_${remainders}`] = true
                        }
                    })
                }
                // this.selectCells = obj
                // this.getSelectDate()
                return obj
            },
            // 详情选中拆回
            getStringTimeToChecked(list) {
                let obj = {}
                if(Array.isArray(list) && list.length != 0) {
                    list.forEach(item=>{
                        let [start,end] = item.split(':') // end 为列，从weekDate取值
                        let endIndex = this.weekDate.findIndex(item=>item===end.toString())

                        obj[`${endIndex}_${start}`] = true
                    })
                }
                this.selectCells = obj
                // this.getSelectDate()
            },
            // 组合时间数据
            getSelectDate () {
                const arrId = []
                const arr = []
                this.weekDate.forEach((item, index) => {
                    arr.push({
                        data: []
                    })
                    for (let i = 0; i < 24; i++) {
                        let o = this.selectCells[`${index}_${i}`]
                        if (o) {
                            let rangTime = `${i}:${item}`
                            // let endTime = startTime + 1
                            //
                            // if (startTime < 10) {
                            //     startTime = '0' + startTime
                            // }
                            // if (endTime < 10) {
                            //     endTime = '0' + endTime
                            // }
                            // startTime += ':00'
                            // endTime += ':00'
                            arr[index].data.push([rangTime])
                            arrId.push(this.setNumTable(index, i))
                        }
                    }
                })
                arr.forEach(item => {
                    for (var i = 0; i < item.data.length; i++) {
                    var o = item.data
                    if (o[i + 1] && o[i][1] === o[i + 1][0]) {
                        o[i + 1][0] = o[i][0]
                        item.data.splice(i, 1)
                        i--
                    }
                    }
                })
                this.selectDate = arr

                let reset_tims = this.selectDate.reduce((prev, cur)=>{
                    cur.data.forEach(item=>{
                        prev.push(item[0])
                    })
                    return prev
                }, [])
                let uniq_list = uniq(reset_tims)
                this.times_list = this.sortedTimes(uniq_list)
                // console.log('选中提交', this.selectDate)
                // console.log('选中提交ID', arrId)
                // console.log('选中的时间段', this.times_list)
                this.$emit('input', this.times_list)
            },
            sortedTimes(times) {
                return sortBy(times, time => {
                    const [minutes, seconds] = time.split(':').map(Number);
                    return minutes * 60 + seconds; // 转换为总秒数
                });
            },
            // 清除选择
            handleClear () {
                if(this.disabled) return
                this.selectCells = {}
                this.getSelectDate()
                this.$forceUpdate()
            },

            // 获取数据
            getData () {
                return this.selectDate
            }
        },
    }
</script>

<style lang="scss" scoped>
.timeRange {
  user-select: none;
  position: relative;
  padding: 10px 0;

  .calendar {
    display: inline-block;
  }
  .tableDisabled{
    .active{
        background-color: #E3E3E3;
    }
  }


  table {
    width: 100%;
    border-radius: 4px;
    border-spacing: 0;
    table-layout: fixed;
    border-collapse: collapse;
      color: #333;

    thead {
      th,
      td {
        height: 16px;
      }
      .weekRow {
        width: 100px;
        min-width: 100px;
          height: 30px;
        padding: 10px 0;
          position: relative;
          overflow: hidden;
          .diagonal_line{
              position: absolute;
              width: 220px;
              height: 1px;
              background-color: #E3E3E3;
              transform: rotate(16deg);
              top: 2px;
              left: -100px;
          }
          .time{
              position: absolute;
              right: 15px;
              top: 5px;
          }
          .minute {
              position: absolute;
              left: 15px;
              bottom: 5px;
          }
      }
    }

    td,
    th {
      outline: 0;
      border: 1px solid #E3E3E3;
      font-size: 12px;
      text-align: center;
      min-width: 12px;
      line-height: 16px;
    }

    tbody {
      position: relative;
      overflow: hidden;

      td {
        height: 16px !important;
        border: 1px dashed #E3E3E3;
      }
    }

    td.active {
      background: #6580ff;
    }
  }

  .table-core {
    line-height: 2.4em;
    border: 1px solid #E3E3E3;
    overflow: hidden;

    .table-core-header {
    //   color: #8A8A8A;
    //   text-align: left;
    //   height: 22px;
    //   line-height: 22px;
    //   margin: 8px 0;
    //   display: flex;
    //   font-size: 12px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #edf3f8;
    }
  }
  .dropTimesTips{
    padding: 10px 0px;
        .star{
            color: #ff0000;
        }
    }
  #box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }
  .drawer_item_time_srcoll{
        width: 100%;
        overflow-y:auto;
        .drawer_item_time{
            display:flex;
            flex-wrap: wrap;
            padding: 0 4px;
            .drawer_item_time_body{
                width: 48px;
                padding-left: 10px;
                color: #333;
                line-height: 26px;
            }
        }
    }
}
</style>
